import { str } from "@lit/localize";
//#region src/generated/locales/en.ts
var templates = {
	"pd.form.field.checkRequired": `Selection required`,
	"pd.form.field.invalid.mail": `Use format mail@test.de`,
	"pd.form.field.invalid.number": `Numbers only allowed`,
	"pd.form.field.invalid.phone": `Use format +49123 123456`,
	"pd.form.field.invalid.vat": `Use format DE0123456789`,
	"pd.form.field.rangeRequired": `Range required`,
	"pd.form.field.required": `Input required`,
	"pd.form.field.selectRequired": `Selection required`,
	"pd.form.required.missing": `* Required field missing or invalid`,
	"pd.form.required.valid": `* Required fields filled`,
	"pd.generic-form.unknown": `Unknown`,
	"pd.input.password.hide": `Hide password`,
	"pd.input.password.show": `Show password`,
	"s512f37f2dba563ec": str`Maximum ${0} characters`,
	"s8a355eeb33f58c5f": str`At least ${0} characters`,
	"pd.form.field.invalid.url": `Gültige URL eingeben (z. B. example.com)`,
	"pd.generic-form.no-data": `Keine Daten vorhanden`,
	"pd.generic-form.yes": `Ja`,
	"pd.generic-form.no": `Nein`,
	"pd.suggestion.box.load.data": `Daten werden geladen`,
	"pd.suggestion.box.error.txt": `Technischer Fehler bei der Suche`,
	"pd.suggestion.box.add.new": str`"${0}" neu anlegen`
};
//#endregion
export { templates };
